<template>

	<div>
		<div class="dashboard-widget-tabs">
			<div class="dashboard-widget-tabs-content">
				<h2>
					<i class="uil uil-chart"></i>
					سرمایه گذاری
				</h2>
				<p>
				خلاصه توضیحات کوتاه درباره این بخش از داشبورد شبکه اطلاع رسانی ارز طلا و سکه
				</p>
				<div class="dashboard-widget-help">
					<i class="uil uil-question-circle"></i>
				</div>
			</div>
			<div class="widget-tabs">
				<div class="widget-tabs-nav">
					<router-link :to="{ name: 'Investment' }" class="m-left m-top tgju-btn tgju-btn-light-orange">
						<i class="uil uil-layer-group"></i> نمای‌کلی
					</router-link>
					<router-link :to="{ name: 'InvestmentInventory' }" class="m-left m-top tgju-btn tgju-btn-light-orange">
						<i class="uil uil-wallet"></i> دارایی ها
					</router-link>
					<router-link :to="{ name: 'InvestmentBuyHistory' }" class="m-left m-top tgju-btn tgju-btn-light-orange active">
						<i class="uil uil-receipt-alt"></i> سوابق خرید
					</router-link>
					<router-link :to="{ name: 'InvestmentSellHistory' }" class="m-left m-top tgju-btn tgju-btn-light-orange">
						<i class="uil uil-receipt-alt"></i> سوابق فروش
					</router-link>
				</div>
			</div>
		</div>
		<div class="row tgju-widgets-row dashboard-widgets-technical-list dash-full-height">
			<div class="col-12">
				<BuyHistoryComponent></BuyHistoryComponent>
			</div>
		</div>
	</div>

</template>

<script>
	// این ویو برای تاریخچه ی خرید در ماژول سرمایه گذاری استفاده میشود
	import BuyHistoryComponent from '@/components/Investment/BuyHistory.vue'

	export default {
		name: 'BuyHistory',
		components: {
			BuyHistoryComponent
		},
		data: function () {
			return {
				widget: {},
				data: {},
			}
		},
	}
</script>